import SimplePage from "./SimplePage";
export default SimplePage;
